import { useMemo } from 'react';

import Chart from '../components/chart';
import type { RmData } from '../graphql/types';
import { displayDate, today } from '../helpers/date-helpers';
import { heatMap } from './heat';

export type Props = {
  data?: RmData[];
  loading: boolean;
  metric?: string;
  name: string;
  reportDate?: string;
};

const HeatMap = ({ data, loading, metric = 'occ_rc', name, reportDate = today() }: Props) => {
  const heatMapOptions = useMemo(() => {
    if (!data) {
      return;
    }

    if (!data.length) {
      return;
    }

    const heatMapDate = displayDate(reportDate);
    const chartOptions = heatMap(data, metric, reportDate);

    return { chartOptions, heatMapDate };
  }, [data, metric, reportDate]);

  if (!heatMapOptions || loading) {
    return <div>Loading {name} Widget...</div>;
  } else {
    return (
      <div className='pt-0'>
        <Chart chartOptions={heatMapOptions.chartOptions} />
      </div>
    );
  }
};

export default HeatMap;
